import calc from '../calculator.png';
import ots from "../images/OTS.png";
import kbc from "../images/KBC.png";
import blog from "../images/blog.JPG"
const proDetails = [
    {
        name: 'Blog Web App',
        details: 'The MERN Stack Blog Web App is a dynamic and user-friendly platform designed for bloggers and readers alike. This web application is built on the popular MERN (MongoDB, Express.js, React, and Node.js) stack, offering a robust and scalable solution for managing and sharing blog content. The project aims to provide a seamless user experience with features for both registered users and administrators.',
        list: [],        
        link: 'https://blog-web-app-n44e.onrender.com/',
        imgSrc: blog
    },
    {
        name: 'MAC',
        details: 'MAC - Multipurpose Advance Calculator , i have developed it in 2019 for my Undergraduate Diploma Course.You can solve many problems through it like -',
        list: [],        
        //list: ['Matrix Manipulation','Quadratic Eq.', 'All 12 number convrsion' , 'Progress Report Generation ', 'Sum of A.P. && G.P.' , 'Area and Volume of different Shapes' , 'ASCII Code of Characters & Integers','GUI Application like appearance.'],
        link: 'https://www.youtube.com/watch?v=MWqlXIJ_ZEg',
        imgSrc: calc
    },
    {
        name: 'OTS',
        details: 'OTS - O Level Test Series, i have made it in 2019 for my own Interest.It\'s a test Series Software where you cn give test like in Online Examination.',
        list: [],
        //list: ['Login/Logout Authentication','Timer Based Test','GUI Application like appearance','Report Generation','Select paper & give Test'],
        link: 'https://www.youtube.com/watch?v=vTjVOcM87VA&t=7s',
        imgSrc: ots
    },{
        name: 'KBC',
        details: 'KBC - Kaun Banega Cororpati , i have also created it for my own interest. It\'s a sound based Game, where you can play KBC with real KBC Game like features & sound.',
        list: [],
        //list: ['Sound with Game','Timer on Questions','Life Lines','Loading Bar'],
        link: 'https://himanshunita.herokuapp.com/',
        imgSrc: kbc
    }
];

export default proDetails ;